







































import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import MarkupsTableRow from '@/components/delivery/markups/MarkupsTableRow.vue'
import { Markup } from '@/dto/deliveries/Markup'
import Delivery from '@/dto/deliveries/Delivery'
import MarkupStore from '@/stores/MarkupStore'
import DictionariesService from '@/services/DictionariesService'
import Currency from '@/dto/deliveries/Currency'

@Component({
  components: { MarkupsTableRow },
})
export default class MarkupsTable extends Vue {
  @Prop(Object) delivery: Delivery

  dictionaries = DictionariesService
  isPending = false

  pagination = {
    rowsPerPage: 1000,
  }

  get currentCurrencySymbol(): string {
    if (!this.delivery.currencyCode) {
      return ''
    }

    return this.dictionaries.currencies[this.delivery.currencyCode].symbol
  }

  get columns() {
    return [
      {
        name: 'project',
        label: 'Проект',
        align: 'left',
        sortable: false,
      },
      {
        name: 'valuePercent',
        label: 'Наценка %',
        align: 'left',
        sortable: false,
      },
      {
        name: 'valueRub',
        label: `добавочная стоимость ${this.currentCurrencySymbol}`,
        align: 'left',
        sortable: false,
      },
      {
        name: 'actions',
        label: '',
        align: 'left',
        sortable: false,
      },
    ]
  }

  get markups(): Markup[] {
    return MarkupStore.markups
  }

  @Watch('delivery', { immediate: true })
  loadMarkups() {
    this.isPending = true

    MarkupStore.load().finally(() => (this.isPending = false))
  }
}
